import React from 'react';
import { BulbOutlined } from '@ant-design/icons';
import { getChatComposerModeShortcutLabel } from '../../composer/chatComposerHotkeys.js';

function firstTruthy(...values) {
  return values.find(Boolean);
}

function conditionalValue(condition, whenTrue, whenFalse = null) {
  return condition ? whenTrue : whenFalse;
}

export function ChatWorkspaceModeSuggestionTip({
  modeSuggestion,
  modeSuggestionAction,
  modeSuggestionActions = [],
  resolvedActiveModeKey,
  modeStatusByKey,
  handleComposerActionSelect,
  setStatusOnlyTipHidden,
  applyBehaviorEvent,
}) {
  if (!modeSuggestionAction) {
    return null;
  }
  const suggestion = Object.assign({}, modeSuggestion);
  const resolvedActions = conditionalValue(
    [Array.isArray(modeSuggestionActions), modeSuggestionActions.length > 0].every(Boolean),
    modeSuggestionActions,
    [modeSuggestionAction]
  );
  const shortcutLabel = getChatComposerModeShortcutLabel(modeSuggestion?.modeKey, resolvedActions);
  const activeModeKey = String(resolvedActiveModeKey ?? '').trim();
  const suggestionModeKey = String(suggestion.modeKey ?? '').trim();
  if ([suggestionModeKey, activeModeKey === suggestionModeKey].every(Boolean)) {
    return null;
  }
  const capabilityLabel = String(firstTruthy(suggestion.label, suggestion.modeKey, '该能力')).trim();
  const suggestionTitle = `检测到可开启能力：${capabilityLabel}`;

  return (
    <div className="flare-workspace-mode-hint" style={{ marginBottom: 8 }}>
      <span className="flare-workspace-mode-hint-icon" aria-hidden="true">
        <BulbOutlined />
      </span>
      <span className="flare-workspace-mode-hint-title">
        {suggestionTitle}
      </span>
      {conditionalValue(Boolean(shortcutLabel), (
        <span className="flare-workspace-mode-hint-shortcut">{shortcutLabel}</span>
      ))}
      <span className="flare-workspace-mode-hint-actions">
        {resolvedActions.map((actionItem, index) => {
          const action = Object.assign({}, actionItem);
          const actionPayload = Object.assign({}, action.action);
          const statuses = Object.assign({}, modeStatusByKey);
          const actionModeKey = String(firstTruthy(actionPayload.target_mode, suggestion.modeKey) ?? '').trim();
          const modeStatus = String(statuses[actionModeKey] ?? '').trim().toLowerCase();
          const isModeStarting = ['starting', 'pending'].includes(modeStatus);
      const actionButtonText = isModeStarting ? '启动中...' : '开启';
          const shouldDisableApply = isModeStarting;
          return (
            <button
              className="flare-workspace-mode-hint-apply"
              type="button"
              key={firstTruthy(action.key, action.text) ?? index}
              disabled={shouldDisableApply}
              onClick={() => {
                if (shouldDisableApply) {
                  return;
                }
                handleComposerActionSelect(actionItem);
              }}
            >
              {actionButtonText}
            </button>
          );
        })}
      </span>
      <button
        className="flare-workspace-mode-hint-close"
        type="button"
        aria-label="关闭提示"
        onClick={() => {
          if (typeof setStatusOnlyTipHidden === 'function') {
            setStatusOnlyTipHidden(true);
          }
          if (typeof applyBehaviorEvent === 'function') {
            applyBehaviorEvent({ type: 'dismiss_mode_suggestion' });
          }
        }}
      >
        ×
      </button>
    </div>
  );
}

export function ChatWorkspaceAuthoritativePendingTip({
  canonicalAwaitingReason,
}) {
  return (
    <div className="flare-workspace-mode-hint" style={{ marginBottom: 8 }}>
      <span className="flare-workspace-mode-hint-icon" aria-hidden="true">
        <BulbOutlined />
      </span>
      <span className="flare-workspace-mode-hint-title">
        {canonicalAwaitingReason
          ? `主流程状态未就绪：${canonicalAwaitingReason}，建议选项将在 canonical 状态修复后展示。`
          : '正在等待主流程确认，建议选项将在 authoritative 状态到达后展示。'}
      </span>
    </div>
  );
}

export function ChatWorkspaceIntakeRunningTip() {
  return (
    <div className="flare-workspace-mode-hint" style={{ marginBottom: 8 }}>
      <span className="flare-workspace-mode-hint-icon" aria-hidden="true">
        <BulbOutlined />
      </span>
      <span className="flare-workspace-mode-hint-title">
        当前正在梳理模式中，请先回答当前关键问题；系统会据此更新右侧正式梳理结果，并继续决定下一问。
      </span>
    </div>
  );
}
